// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2V3uc","addWidgetButton":"Header_addWidgetButton__g_919","dashboardTabs":"Header_dashboardTabs__2XVkF","active":"Header_active__178M4"};